import {
    Card,
    CardContent,
    CardMedia,
    IconButton,
    Typography,
} from '@mui/material'
import React from 'react'
import ReactPlayer from 'react-player'
import styled from 'styled-components'
import StarRateIcon from '@mui/icons-material/StarRate'
import {yellow} from '@mui/material/colors'
import StarOutlineIcon from '@mui/icons-material/StarOutline'

const MediaCard = ({_id, url, name, isMain, onClick}) => {
    return (
        <StyledCard sx={{width: 250}}>
            <CardMedia>
                <ReactPlayer url={url} width="100%" height="150px" controls />
            </CardMedia>
            <CardContent>
                {name && <Text variant="subtitle1">{name}</Text>}
                {isMain ? (
                    <IconButton>
                        <StarRateIcon
                            sx={{color: yellow[700]}}
                            fontSize="large"
                        />
                    </IconButton>
                ) : (
                    <IconButton onClick={() => onClick(_id)}>
                        <StarOutlineIcon
                            sx={{color: yellow[700]}}
                            fontSize="large"
                        />
                    </IconButton>
                )}
            </CardContent>
        </StyledCard>
    )
}

export default MediaCard

const StyledCard = styled(Card)`
    width: 250px;
`

const Text = styled(Typography)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
`
